import { GridColDef } from '@mui/x-data-grid-pro';

export const getDomainUsersColumns = (): GridColDef[] => {
  return [
    {
      field: 'domain',
      headerName: 'Domain',
      minWidth: 200,
      flex: 1,
      type: 'string',
      sortingOrder: ['asc', 'desc'],
    },
    {
      field: 'userCount',
      headerName: 'No. of Users',
      minWidth: 200,
      flex: 1,
      type: 'number',
      sortingOrder: ['asc', 'desc'],
    },
  ];
};
